export enum ENDPOINT_NAMES {
  GET_CHAT_INFO = "get_chat_info",
  GET_CHAT_SETTINGS = "get_chat_settings",
  GET_MESSAGES = "get_messages",
  GET_PREV_MESSAGES = "get_prev_messages",
  GET_NEXT_MESSAGES = "get_next_messages",
  GET_MESSAGES_BY_REPLY = "get_messages_by_reply",
  POST_CHAT_INFO = "post_chat_info",
  POST_MESSAGE = "post_message",
  POST_EVENT_MESSAGE_READING = "post_event_message_reading",
  POST_EVENT_USER_TYPING = "post_event_user_typing",
}
